"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOREDASH = exports.NONE = exports.CONTACTLIST = exports.APPS = exports.GMB = exports.LOGO = exports.STORE = exports.WHITE_LABEL_EMAIL = exports.EMAIL_CAMPAIGN = exports.EMAIL = exports.GWS = exports.GSUITE = exports.BLOG = exports.SITE = exports.DOMAIN = exports.ACCOUNT = void 0;
var ACCOUNT = 'account';
exports.ACCOUNT = ACCOUNT;
var DOMAIN = 'domain';
exports.DOMAIN = DOMAIN;
var SITE = 'site';
exports.SITE = SITE;
var BLOG = 'blog';
exports.BLOG = BLOG;
var GSUITE = 'gsuite';
exports.GSUITE = GSUITE;
var GWS = 'gws';
exports.GWS = GWS;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var EMAIL_CAMPAIGN = 'email_campaign';
exports.EMAIL_CAMPAIGN = EMAIL_CAMPAIGN;
var WHITE_LABEL_EMAIL = 'white_label_email';
exports.WHITE_LABEL_EMAIL = WHITE_LABEL_EMAIL;
var STORE = 'store';
exports.STORE = STORE;
var LOGO = 'logo';
exports.LOGO = LOGO;
var GMB = 'gmb';
exports.GMB = GMB;
var APPS = 'apps';
exports.APPS = APPS;
var CONTACTLIST = 'contactlist';
exports.CONTACTLIST = CONTACTLIST;
var NONE = 'none';
exports.NONE = NONE;
var STOREDASH = 'storedash';
exports.STOREDASH = STOREDASH;